import React, { createContext, useContext } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const ToastContext = createContext(); 

export const ToastProvider = ({ children }) => {
  const notify = (message, type = 'info', onClick = null) => {
    const options = {
      onClick: onClick ? () => onClick() : undefined, 
    };

    switch (type) {
      case 'success':
        toast.success(message, options);
        break;
      case 'error':
        toast.error(message, options);
        break;
      case 'warning':
        toast.warn(message, options);
        break;
      case 'info':
      default:
        toast.info(message, options);
        break;
    }
  };

  return (
    <ToastContext.Provider value={notify}>
      {children}
      <ToastContainer hideProgressBar={true} autoClose={5000} theme='dark' />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  return useContext(ToastContext);
};
